module.exports = __webpack_public_path__ + "img/concrete-hole-decal-25.ff0b6d4f.png";